import { Card, Badge, Button, Group, Text, Stack, Tooltip } from "@mantine/core";
import { IconClock, IconToolsKitchen2, IconShield, IconShieldOff, IconShieldHalf } from "@tabler/icons-react";
import { motion } from "framer-motion";

const RatePlanCard = ({ plan, handleEdit, handleDelete }) => {

  const mealLabels = {
    none: null,
    breakfast: "🍳 Petit-déjeuner",
    half_board: "🍽️ Demi-pension",
    full_board: "🍽️ Pension complète"
  };

  const policyConfig = {
    free: {
      label: "Annulation gratuite",
      color: "green",
      icon: <IconShield size={13} />
    },
    partial: {
      label: `Partielle — ${plan.cancellationPolicy?.penaltyPercentage}%`,
      color: "yellow",
      icon: <IconShieldHalf size={13} />
    },
    non_refundable: {
      label: "Non remboursable",
      color: "red",
      icon: <IconShieldOff size={13} />
    }
  };

  const policy = policyConfig[plan.cancellationPolicy?.type] || policyConfig.free;
  const meal = mealLabels[plan.mealPlan];

  return (
    <motion.div whileHover={{ y: -4 }} transition={{ duration: 0.15 }}>
      <Card
        shadow="xs"
        radius="xl"
        p="lg"
        withBorder
        style={{
          borderColor: "#f0f0f0",
          height: "100%"
        }}
      >
        <Stack gap="md" h="100%" justify="space-between">

          {/* HEADER */}
          <div>
            <Text size="xs" c="dimmed" mb={4} tt="uppercase" fw={600} style={{ letterSpacing: "0.05em" }}>
              Tarif
            </Text>

            <Tooltip label={plan.name} position="top">
              <Text
                fw={700}
                size="lg"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  color: "#111"
                }}
              >
                {plan.name}
              </Text>
            </Tooltip>

            {plan.description && (
              <Text size="xs" c="dimmed" mt={4} lineClamp={2}>
                {plan.description}
              </Text>
            )}
          </div>

          {/* BADGES */}
          <Stack gap="xs">

            {/* Politique annulation */}
            <Badge
              variant="light"
              color={policy.color}
              radius="md"
              leftSection={policy.icon}
              style={{ width: "fit-content" }}
            >
              {policy.label}
            </Badge>

            {/* Repas */}
            {meal && (
              <Badge
                variant="light"
                color="blue"
                radius="md"
                leftSection={<IconToolsKitchen2 size={13} />}
                style={{ width: "fit-content" }}
              >
                {meal}
              </Badge>
            )}

            {/* Heures annulation si free ou partial */}
            {plan.cancellationPolicy?.type !== "non_refundable" &&
              plan.cancellationPolicy?.hoursBeforeArrival > 0 && (
              <Badge
                variant="outline"
                color="gray"
                radius="md"
                leftSection={<IconClock size={13} />}
                style={{ width: "fit-content" }}
              >
                Jusqu'à {plan.cancellationPolicy.hoursBeforeArrival}h avant
              </Badge>
            )}

          </Stack>

          {/* ACTIONS */}
          <Group mt="xs" gap="xs">
            <Button
              size="xs"
              radius="xl"
              variant="filled"
              color="green"
              onClick={() => handleEdit(plan)}
              style={{ flex: 1 }}
            >
              Modifier
            </Button>

            <Button
              size="xs"
              radius="xl"
              variant="light"
              color="red"
              onClick={() => handleDelete(plan)}
              style={{ flex: 1 }}
            >
              Supprimer
            </Button>
          </Group>

        </Stack>
      </Card>
    </motion.div>
  );
};

export default RatePlanCard;